import React from 'react'

import DarazManual from 'app/common/Stores/Daraz/DarazManual'
import ShopifyManual from 'app/common/Stores/Shopify/ShopifyManual'
import WooCommerceManual from 'app/common/Stores/Woo/WooCommerceManual'
import {
  DcButton,
  PixelFactoryContext,
  PixelFlexBox,
  PixelHeaderPanel,
} from 'pixel-base'
import { ArrowLeftIcon } from 'utils/icons/arrow-left-icon'

const ManualFlow = (props: any) => {
  const { activestore, onBack, onUpdateInfo } = props
  const { showSuccess } = React.useContext<IPixelFactory>(PixelFactoryContext)

  const onSuccessAddStore = () => {
    showSuccess('Successfully Added')
    onUpdateInfo()
  }

  const renderManualFlows = () => {
    switch (activestore.slug) {
      case 'woocommerce':
        return <WooCommerceManual />
      case 'shopify':
        return (
          <ShopifyManual
            origin="onboarding"
            onSuccessAddStore={onSuccessAddStore}
          />
        )
      case 'daraz':
        return (
          <DarazManual
            origin="onboarding"
            onSuccessAddStore={onSuccessAddStore}
          />
        )
    }
    const NotImplemented = () => <>not Implemented</>
    NotImplemented.displayName = 'NotImplemented'
    return NotImplemented
  }

  return (
    <PixelFlexBox
      flexDirection="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      alignContent="flex-start"
      style={{
        borderRadius: '5px',
      }}
      width="100%"
      height="100%"
    >
      <PixelHeaderPanel height="auto" alignContent="center" padding="10px 0px">
        <div>{activestore.icon}</div>
        <div>
          <PixelFlexBox
            height="auto"
            justifyContent="center"
            alignItems="center"
          >
            <DcButton onClick={onBack} size="sm" withIcon={true}>
              <ArrowLeftIcon size={16} />
              <span>Back</span>
            </DcButton>
          </PixelFlexBox>
        </div>
      </PixelHeaderPanel>
      <PixelFlexBox
        flexDirection="column"
        justifyContent="flex-start"
        alignItems="flex-start"
        alignContent="flex-start"
        width="100%"
        height="100%"
      >
        {renderManualFlows()}
      </PixelFlexBox>
    </PixelFlexBox>
  )
}

ManualFlow.displayName = 'ManualFlow'

export default ManualFlow
